export default {
  home: '首頁',
  document_title: 'IP廣播對講軟件',
  document_title_fusion: 'IP指揮調度軟件',
  login_title: 'IP廣播對講軟件',
  login_title_fusion: 'IP指揮調度軟件',
  login: '登錄',
  logining: '登錄中...',
  login_success:'登錄成功',
  login_fail:'登錄失敗',
  not_open_fast_login:'快捷登錄未開啓',
  open:'開啓',
  close:'關閉',
  dispatch: '調度控制台',
  setting: '設置',
  user_setting: '個人設置',
  full_screen: '全屏',
  logout: '退出',
  otherLogin: '異地登錄',
  loginError: '用戶名或密碼錯誤！',
  systemIsUpgrade: '系統正在升級中，請稍候！',
  reLoginTitle: '賬號重復登錄',
  reLoginContent: '該賬號已經登錄，是否註銷上一個登錄，並登錄？',
  unknown_error: '未知錯誤',
  update_password: '修改密碼',
  old_pass: '舊密碼',
  new_pass: '新密碼',
  again_pass: '確認密碼',
  old_pass_placeHolder: '請輸入舊密碼',
  new_pass_placeHolder: '請輸入新密碼',
  again_pass_placeHolder: '請再次輸入新密碼',
  password_error: '密碼至少6位,同時包含字母和數字',
  password_error1: '原密碼錯誤',
  password_error2: '兩次輸入密碼不一致',
  searchTip: '輸入關鍵字搜索',
  searchTime: '請選擇時間',
  search: '搜索',
  total: '共',
  item: '條',
  sure: '確認',
  cancel: '取消',
  upload: '上傳',
  collapsed: '展開/收起',
  exportFile: '導出',
  importFile: '導入',
  exportTemp: '下載導入模板',
  no_data: '無數據',
  conf_displayNum: '系統中未配置會議顯示號碼',
  file: '文件',
  info: '太大，超過10M',
  format_err: '格式不正確，請選擇jpg，jpeg或png',
  operate_success: '操作成功!',
  operate_complete: '操作完成!',
  operate_fail: '操作失敗!',
  exten_change: '分機狀態改變，請重新登錄！',
  exten_offline: '分機不在線或分機忙碌',
  success: '成功',
  fail: '失敗',
  unknown: '未知',
  unsend: '未發送',
  yes: '是',
  no: '否',
  multiple: '多選',
  single: '單選',
  col: '列',
  row: '行',
  enable: '啟用',
  disable: '不啟用',
  isNumber: '不是數字',
  no_select_exten: '待選分機',
  selected_exten: '已選分機',
  noData: '暫無數據',
  exten: '分機號',
  outLine: '未知',
  calling_pre: '來電號碼',
  caller_pre: '被叫號碼',
  fileError: '文件格式錯誤',
  server_error: '服務器錯誤！',
  enter_name: '請輸入用戶名',
  enter_password: '請輸入密碼',
  enter_code: '請輸入驗證碼',
  name_null: '用戶名不能為空',
  password_null: '密碼不能為空',
  code_null: '驗證碼不能為空',
  code_title: '點擊刷新',
  code_success: '驗證碼正確',
  code_fail: '驗證碼錯誤',
  message_error: '消息錯誤',
  title: 'IP廣播對講軟件',
  is_auto_accept: '自動接聽',
  auto_type: '接聽方式',
  webRtc_auto: '默認',
  webRtc_audio: '語音',
  webRtc_video: '視像',
  console_video_button:'視像按鈕',
  video_call: '視像通話',
  audio_accept: '語音接聽',
  audio_call_out: '語音呼出',
  video_call_out: '視像呼出',
  video_accept: '視像接聽',
  call_tip: '呼叫來電',
  call_type: '呼叫方式',
  answer_call: '接聽',
  reject_call: '拒接',
  call_content: '電話:',
  call_content_append: ',來電！',
  control: '控製臺',
  no_exten_inline: '無控製分機在線',
  control_busy: '控製話機繁忙',
  call: '呼叫',
  left_mobile: '左話機',
  right_mobile: '右話機',
  inline: '在線',
  offline: '離線',
  talk: '通話',
  ring: '振鈴',
  answer: '應答',
  handup: '掛斷',
  terminal_number: '終端號碼',
  terminal_name: '終端名稱',
  terminal_ip: '終端IP',
  callee_queue: '來電隊列',
  caller_queue: '當前通話',
  enterqueue: '進入隊列',
  leavequeue: '離開隊列',
  and: ' 與 ',
  unanswer: '未接來電',
  unanswer_time: '呼叫時間',
  current_area: '當前區域',
  partition_conf: '分區會議',
  partition_pag: '分區喊話',
  partition_broad: '分區廣播',
  device_station: '終端分區',
  device_name: '終端名稱',
  device_station_small: '位置',
  device_name_small: '名稱',
  device_dept: '所屬分區',
  intercom: '對講',
  hangup: '掛斷',
  monitor: '監聽',
  barge: '強插',
  take_over: '拆講',
  secret: '密語',
  transfer: '轉駁',
  more_conf: '多方會議',
  more_broad: '多方廣播',
  more_pro: '多方喊話',
  group_info: '組織信息',
  all_area: '全部分區',
  private: '私有',
  only_admin: '僅管理員可見',
  sure_ebs: '播放/停止 ?',
  play: '播放',
  stop: '停止',
  no_bro: '無緊急廣播任務',
  stop_bro: '緊急廣播未啟用',
  Idle: '空閑',
  Idel: '空閑',
  Talking: '通話',
  Ringing: '振鈴',
  OffLine: '離線',
  UnKnow: '未知',
  UnKnown: '未知',
  Broading: '廣播',
  unSelectExt: '請選擇終端',
  unCheckExt: '請勾選終端',
  checkOffLineExt: '請選擇支持離線的終端',
  unCheckOffLineExt: '請勾選支持離線的終端',
  conference: '會議室',
  videoConference: '視頻會議',
  broadcast: '廣播任務',
  broad_type: '廣播類型',
  time_broad: '定時任務',
  state_broad: '運行狀態',
  state_exten: '設備狀態',
  state_bro: '進行中任務',
  all_broad: '全部任務',
  music_broad: '音樂任務',
  pro_broad: '喊話任務',
  word_broad: '文字任務',
  see_broad: '采播任務',
  outside_broad: '外部任務',
  file_broad: '文件任務',
  offline_broad: '離線任務',
  broad_plan: '廣播方案',
  broad_log: '廣播記錄',
  change_plan: '方案切換',
  music_broad_not_suffix: '音樂',
  pro_broad_not_suffix: '喊話',
  word_broad_not_suffix: '文字',
  see_broad_not_suffix: '采播',
  file_broad_not_suffix: '文件',
  offline_broad_not_suffix: '離線',
  broad_pstn: '接入號',
  broad_status: '狀態',
  broad_task: '類型',
  broad_model: '模式',
  broad_time: '播放時間',
  broad_order: '播放模式',
  broad_priority: '優先級',
  broad_tone: '提示音',
  broad_volumn: '音量',
  broad_pro: '進度',
  one_level: '超緊急',
  two_level: '高',
  three_level: '中',
  four_level: '低',
  nostart_status: '未開始',
  start_status: '開始',
  play_status: '進行中',
  end_status: '結束',
  pause_status: '暫停',
  sending: '下發中',
  send_complete: '下發完成',
  part_fail: '部分失敗',
  model_one: '即時廣播',
  model_two: '定時廣播',
  model_three: '觸發廣播',
  model_four: '離線廣播',
  model_one_not_suffix: '即時',
  model_two_not_suffix: '定時',
  model_three_not_suffix: '觸發',
  order_model: '順序',
  random_model: '隨機',
  cir_model: '循環',
  no_cir_model: '不循環',
  end: '結束',
  delete: '刪除',
  volume: '音量',
  add: '添加',
  batchDelete: '批量刪除',
  confirm_delete: '確認刪除',
  confirm_delete_record: '確定要刪除這條抓拍記錄嗎？',
  confirm_delete_video_record: '確定要刪除這條錄像記錄嗎？',
  delete_success: '刪除成功',
  delete_fail: '刪除失敗',
  select_record_first: '請先選擇要刪除的記錄',
  confirm_batch_delete: '確認批量刪除',
  confirm_batch_delete_records: '確定要刪除選中的 {count} 條記錄嗎？',
  confirm_delete_search_records: '確定要刪除搜索結果中的所有記錄嗎？',
  batch_delete_success: '批量刪除成功',
  batch_delete_fail: '批量刪除失敗',
  update: '編輯',
  copy:'復製',
  no_operate: '不能操作',
  every: '每',
  week_one: '周一',
  week_two: '周二',
  week_three: '周三',
  week_four: '周四',
  week_five: '周五',
  week_six: '周六',
  week_seven: '周日',
  no_select_bro: '請選擇廣播',
  select_more_bro: '請選擇一條廣播!',
  has_unsupport_exten: '含有不支持離線的分機',
  task_sync_complete: '同步完成',
  task_sync_renew: '已重新同步',
  task_sync_fail: '同步失敗',
  no_start_bro: '廣播未開始',
  delete_bro: '刪除廣播?',
  /*broad form*/
  broadName: '廣播名稱',
  broadPriority: '優先級',
  broadPlayNum: '播放次數',
  broadPstn: '廣播接入號',
  broadTone: '提示音',
  broadAccessPw: '接入號密碼',
  broadType: '廣播類型',
  broadVolumn: '音量',
  broadOrder: '排序',
  broadValidity: '任務有效期',
  permanentValidity: '永久有效',
  placeholderValidity: '請選擇有效期',
  broadTime: '播放時長',
  broadPlayQueue: '播放列表',
  musicQueue: '音樂列表',
  broadPlayType: '播放方式',
  broadUpdateFile: '上傳文件',
  broadMusic: '音樂文件',
  notice_content: '提示內容',
  placeholderMusic: '請選擇音樂文件',
  placeholderText: '請選擇txt格式文件',
  placeholder_notice: '請輸入提示內容',
  uploadMusic: '上傳音樂文件',
  musicName: '音樂名稱',
  musicPath: '音樂文件',
  musicRemark: '音樂備註',
  musicVolume: '音樂音量',
  placeholderMusicName: '請輸入音樂名稱',
  placeholderMusicPath: '請上傳音樂文件',
  placeholderMusicRemark: '請輸入音樂備註',
  placeholderMusicVolume: '請選擇音樂音量',
  placeholderOrder: '請輸入排序',
  musicNameEmpty: '音樂名稱不能為空',
  musicFileEmpty: '音樂文件不能為空',
  musicVolumeEmpty: '音樂音量不能為空',
  broadText: '文字內容',
  broadSee: '采播終端',
  broadFileType: '播放類型',
  placeholderBroadType: '請選折播放類型',
  tts: '文檔',
  voice: '語音',
  txt_content: '文本內容',
  txt_file: '文本文件',
  vioce_file: '語音文件',
  broadTimeType: '定時方式',
  broadFixedTime: '固定時間',
  broadWeekly: '按周循環',
  /*form placeHolder*/
  bnameplaceHolder: '請輸入廣播名稱',
  bpriorityplaceHolder: '請選擇優先級',
  bplayNumplaceHolder: '請輸入廣播次數',
  bpstnplaceHolder: '請選擇接入號',
  btoneplaceHolder: '請選擇提示音',
  baccessPwplaceHolder: '請輸入接入號密碼',
  btypeplaceHolder: '請選擇廣播類型',
  btimeplaceHolder: '請輸入廣播時長（分鐘）',
  bplayQueueplaceHolder: '請選擇播放列表',
  bplayTypeplaceHolder: '請選擇播放模式',
  bseeplaceHolder: '請選擇采播終端',
  buploadFileplaceHolder: '請選擇文件',
  btextplaceHolder: '請輸入文本',
  bfplaceHolder: '請選擇播放時間',

  /*form validate*/
  name_vali: '廣播名稱不能為空',
  priority_vali: '廣播優先級不能為空',
  play_times_vali: '播放次數不能為空',
  lasting_time_vali: '播放時長不能為空',
  capture_dev_vali: '采播終端不能為空',
  access_num_vali: '廣播接入號不能為空',
  prompt_tone_vali: '廣播提示音不能為空',
  access_num_pw_vali: '廣播接入號密碼不能為空',
  temp_volume_vali: '音量不能為空',
  play_list_id_vali: '播放列表不能為空',
  play_music_idvali: '音樂不能為空',
  playing_mode_vali: '播放模式不能為空',
  text_content_vali: '文字內容不能為空',
  exten_vali: '註：終端號不能為空',
  authority_vali: ',許可權外終端不可操作',
  check_exten_vali: '請選擇終端',
  file_vali: '文件不能為空',
  playing_time_vali: '廣播時間不能為空',
  broadcast_time_vali: '廣播時間不能為空',
  broadcast_effect_time_vali: '生效時間不能為空',
  broadcast_weekday_time_vali: '每周不能為空',
  type_vali: '廣播類型不能為空',
  holiday: '節假日',
  placeholderHoliday: '請選擇節假日時間',
  month: '月份',
  date: '日期',
  startTime: '開始時間',
  endTime: '截至時間',
  remark: '備註',
  operation: '操作',

  same_name_vali: '廣播名稱已存在',
  exten_has_cross_time: '分機存在交叉時間',
  each_week: '每週',
  effective_time: '生效時間',
  select_time: '選擇時間',
  terminal_file: '終端檔案',
  offline_task: '離線任務',
  edit_volume: '編輯音量',
  task_asyc: '任務同步',
  update_volume: '修改音量',
  task_asys_detail: '任務同步詳情',
  broadcast_task: '廣播任務',
  file_name: '檔案名稱',
  file_address: '檔案地址',
  asyc_status: '下發狀態',
  fail_reason: '失敗原因',
  retry: '重試',
  force_delete: '強制删除',
  resend: '重新下發',
  word: '文字',
  whether_open: '是否啟用',
  has_open: '已啟用',
  not_open: '未啟用',

  searchDevice: '請輸入終端號碼',

  b_number: '號碼',
  b_name: '名稱',
  b_status: '狀態',
  b_volume: '音量',
  b_ip: 'IP',
  b_mac: 'MAC',
  b_type: '類型',
  b_model: '型號',
  b_support_offline: '支持離線',
  support: '是',
  unsupport: '否',
  /**同步狀態*/
  issuedStatus_0: '開始同步',
  issuedStatus_1: '同步中',
  issuedStatus_2: '已同步',
  issuedStatus_3: '同步失敗',
  issuedStatus_4: '開始删除',
  issuedStatus_5: '删除中',
  issuedStatus_6: '删除失敗',

  /**失敗原因*/
  failReason_1: '發送失敗',
  failReason_2: '響應超時',

  standGuard: '無人看守',
  transfer_phone: '來電轉駁號碼',
  enterphone: '請輸入值守號碼',
  startStand: '開始無人看守',
  standing: '正在無人看守',
  cancel_stand: '取消無人看守',
  stand_error: '無人看守失敗',
  phone_error: '手機號錯誤',
  warning: '警報',
  device_alarm: '終端警報',
  warning_type: '警報類型',
  warning_unrelease: '未解除警報',
  warning_release: '已解除警報',
  warning_level: '警報級別',
  warning_source: '警報源',
  warning_devName: '警報終端名',
  warning_status: '警報狀態',
  warning_happenTime: '警報發生時間',
  warning_releaseTime: '警報解除時間',
  warning_remark: '警報備註',
  warning_sure: '警報確認',
  warning_remove: '警報解除',
  warning_content: '警報内容',
  level_one: '一級',
  level_two: '二級',
  level_three: '三級',
  status_one: '新警報',
  status_two: '已確認',
  status_three: '已解除',
  is_alarm: '是警報',
  is_unalarm: '非警報',
  no_sure_alarm: '警報未確認',
  no_select_alarm: '請選擇一條警報',
  ignore: '忽略',
  video: '視像監控',
  no_support_play: '該攝像頭不支持預覽',
  camera: '攝像頭',
  reload: '請重新加載',
  recording: '錄像開始',
  stop_record: '錄像結束',
  img_record: '抓拍成功',
  image_look: '抓拍記錄',
  video_look: '錄像記錄',
  call_btn: '呼叫',
  image_record_btn: '截屏',
  image_web_record_btn: '抓拍',
  video_record_start_btn: '開始錄屏',
  video_record_stop_btn: '結束錄屏',
  ptz_btn: '雲臺控製',
  close_btn: '關閉',
  stop_rtmp: '關閉成功',
  image_name: '圖片名稱',
  video_name: '視像名稱',
  create_date: '創建時間',
  action: '操作',
  view: '查看',
  playVideo: '播放',
  download: '下載',
  generator: '生成',
  hostInfo_tip: '生成 HostInfo',
  hostInfo_content: '此操作會生成一個新的HostInfo文件並且覆蓋舊的文件。',
  view_image: '查看圖片',
  view_video: '查看視像',
  no_camera: '未選擇攝像頭',
  message_live_scan: '掃碼查看',
  camera_no_active: '攝像頭未激活',
  camera_connected: '攝像頭連接失敗',
  no_free_windows: '未有空閑視窗，是否替換最後一個打開的視窗？',
  line_limit: '轉流線數已達上限',
  map: '電子地圖',
  device: '終端',
  baidu_map: '地圖視圖',
  diy_map: '場景視圖',
  edit_map: '編輯地圖',
  current_device: '當前終端',
  had_device: '終端已存在地圖中',
  del_device: '刪除終端',
  upload_diy: '上傳場景圖',
  del_content: '刪除地圖中',
  del_content_last: '個終端',
  select_device: '請選擇圖中終端',
  reserve_plan: '預案',
  reserve_plan_title:'預案',
  reporting_information: '上報信息',
  execute_plan: '是否執行預案',
  hasPlan: '預案已存在',
  delete_plan: '刪除預案',
  no_select_plan: '請選擇預案',
  select_more_plan: '請選擇一條預案!',
  plan_type: '預案類型',
  all_plan: '全部預案',
  tamper_type: '防拆警報',
  oneKey_type: '一鍵警報',
  waln_type: '網關警報',
  device_empty: '終端不能為空',
  camera_empty: '攝像頭不能為空',
  trigger_one: '自動',
  trigger_two: '手動',
  trigger_three: '關閉',
  plan_device_name: '終端/攝像頭名稱',
  part_name: '分區/端口',
  alarm_type: '警報類型',
  trigger_mode: '觸發模式',
  alarm_type_placeHolder: '請選擇警報類型',
  trigger_mode_placeHolder: '請選擇觸發模式',
  placeholder_camera: '請選擇攝像頭',
  plan_link_modal: '預案聯動',
  linkPlan: '聯動',
  haikang: '海康',
  dahua: '大華',
  sanli: '金三立',
  fangwei: '方位',
  other: '其他',
  broad: '廣播',
  sms: '短信',
  sms_phone: '短信號碼',
  sms_content: '短信內容',
  editable: '短信模板可編輯項不能為空',
  camera_name: '攝像頭標識名稱',
  camera_brand: '攝像頭品牌',
  camera_address: 'IP 地址',
  camera_port: '端口號',
  camera_initial_count: '初始化帳號',
  exten_placeHolder: '請輸入分機號',
  queuing_notice: '排程通知',
  delete_notice: '刪除通知',
  notice: '通知',
  notice_type: '通知類型',
  all_notice: '全部通知',
  word_notice: '文字通知',
  record_notice: '錄音通知',
  notice_access_num: '接入號碼',
  notice_display_num: '顯示號碼',
  name: '名稱',
  notice_status: '執行狀態',
  notice_start_time: '啟動時間',
  notice_ttype: '類型',
  notice_ntype: '方式',
  notice_model: '模式',
  notice_call_num: '呼叫數',
  notice_called_num: '已呼數',
  notice_uncall_num: '未呼數',
  notice_volume: '音量',
  notice_call_pre: '已呼率',
  notice_uncall_pre: '未呼率',
  notice_accept_pre: '已接率',
  one_type: '即時通知',
  two_type: '定時通知',
  three_type: '觸發通知',
  detail: '詳情',
  select_more_notice: '請選擇一條通知',
  no_select_notice: '請選擇通知',
  detail_modal: '詳細信息',
  index: '序號',
  tel: '號碼',
  start_time: '開始時間',
  ring_time: '振鈴時間',
  answer_time: '應答時間',
  hangup_time: '掛斷時間',
  call_result: '呼叫結果',
  send_result: '發送結果',
  call_status: '呼叫狀態',
  call_count: '呼叫次數',
  call_out: '已呼出',
  call_answer: '客戶應答',
  call_hang: '客戶掛斷',
  notice_name: '通知名稱',
  retry_num: '重試次數',
  concurrency_num: '並發線數',
  concurrency_num_check: '並發綫數建議填寫1-9999',
  redial_times_check: '重試次數建議填寫0-99',
  notice_access: '通知接入號',
  notice_access_pw: '接入號密碼',
  notice_display: '顯示號碼',
  ring_times: '振鈴時長',
  sys_tel: '系統號碼',
  file_tel: '導入號碼',
  file_tip: '(","分隔號碼的txt文件)',
  record_file: '錄音文件',
  notice_text: '文字內容',
  select_type: '號碼選擇方式',
  notice_tel: '已選號碼',
  tel_tip: '(","分隔號碼)',
  is_use: '是否啟用',
  is_mpa: 'MP3高音質',
  recv_btn: '按鍵采集',
  btn_val: '按鍵',
  notice_end: '按鍵確認提示音',
  endPlaceholder: '請選擇按鍵確認提示音',
  nnplaceholder: '請輸入通知名稱',
  nrplaceholder: '請輸入重試次數',
  ncplaceholder: '請輸入並發數',
  naplaceholder: '請選擇接入號',
  ndplaceholder: '請選擇顯示號碼',
  napplaceholder: '請輸入接入號密碼',
  nrtplaceholder: '請輸入振鈴時長',
  ntplaceholder: '請選擇通知類型',
  nrfplaceholder: '請選擇錄音文件',
  ntcplaceholder: '請輸入文字內容',
  ntsplaceholder: '請輸入通知號碼',
  n_sms_vali: '短信不能為空',
  n_name_vali: '通知名稱不能為空',
  n_retry_vali: '重試次數不能為空',
  n_type_vali: '類型不能為空',
  n_max_vali: '並發線數不能為空',
  n_pstn_vali: '接入號不能為空',
  n_pass_vali: '接入號密碼不能為空',
  n_d_vali: '顯示號碼不能為空',
  n_r_vali: '振鈴時長不能為空',
  n_record_vali: '錄音文件不能為空',
  n_text_vali: '文字內容不能為空',
  n_exten_vali: '通知號碼不能為空',
  n_time_vali: '通知時間不能為空',
  n_week_vali: '循環時間不能為空',
  n_access_num_vali: '通知接入號不能為空',
  sys_ext: '系統分機',
  address_book: '通訊錄',
  contacts: '聯絡人',
  linkman_group: '分組列表',
  linkman_name: '聯絡人名稱',
  linkman_phone: '聯絡人電話',
  linkman_groupname: '分組名',
  linkman_vip: 'VIP',
  linkman_remark: '備註',
  linkman_self: '類型',
  send: '發送',
  sendMsg: '發送短信',
  sendFilter: '發送過濾',
  sendSelect: '按選擇結果發送',
  sendSearch: '按搜索結果發送',
  selecttemplate: '短信模板',
  sendData: '發送內容',
  pleaseSelect: '請選擇',
  pleaseInput: '請輸入',
  all_link: '全部聯絡人',
  sendContentNull: '發送內容不能為空',
  sendPhoneNull: '發送的號碼不能為空',
  sendFail: '發送失敗',
  sendSuccess: '發送成功',
  sendTypeNull: '發送類別不能為空',
  notice_fun: '通知方式',
  smsType: '短信通知',
  voiceType: '語音通知',
  smsAndVoiceType: '語音及短信通知',
  noAnswerSmsType: '未接通短信通知',
  l_linkman_name_empty: '聯絡人名稱不能為空',
  l_link_phone_empty: '聯絡人電話不能為空',
  l_linkman_phone_empty: '聯絡人電話不能為空',
  l_group_empty: '分組不能為空',
  l_vip_empty: 'VIP不能為空',
  l_link_group_name_empty: '分組名稱不能為空',
  l_link_group_name_exist: '分組名已存在',
  broad_link: '廣播聯動',
  video_link: '視像聯動',
  video_link_max: '視像聯動數量已達最大',
  get_video: '獲取視像地址出錯',
  sms_link: '短信聯動',
  no_svl: '請選擇一條視像聯動',
  no_ssl: '請選擇一條短信聯動',
  broad_name_placeHolder: '請選擇廣播任務',
  video_name_placeHolder: '請選擇攝像頭',
  sms_phone_placeHolder: '請輸入短信號碼',
  sms_content_placeHolder: '請輸入短信內容',
  select_more_group: '請選擇一條分組',
  no_select_group: '未選擇分組',
  cameraname_placeHolder: '請輸入監視器名稱',
  lname_placeHolder: '請輸入聯絡人名稱',
  lphone_placeHolder: '請輸入聯絡人號碼',
  lgroup_placeHolder: '請選擇分組',
  lvip_placeHolder: '請選擇',
  lremark_placeHolder: '請輸入備註',
  select_more_link: '請選擇一個聯絡人',
  no_select_link: '未選擇聯絡人',
  delete_linkman: '刪除聯絡人',
  group: '分組',
  group_btn: '分組',
  group_manager: '聯絡人分組管理',
  delete_group: '刪除分組',
  delete_ginfo: '，以及分組下的所有聯絡人',
  lgname_placeHolder: '請輸入分組名稱',
  no_link_phone: '聯絡人無號碼',
  link_phone_error: '聯絡人碼不正確',
  system: '系統管理',
  emergency: '緊急廣播',
  emergency_running:'播放中',
  edition_title: 'IP廣播對講軟件',
  edition_title_fusion: 'IP指揮調度軟件軟件',
  user_account: '賬號',
  agent_extension: '座席分機',
  curr_time: '當前時間',
  serverunconnected: '服務器未連接',
  serverconnected: '服務器已連接',
  components: '組件',
  count_to_page: '數字漸變',
  tables_page: '多功能表格',
  split_pane_page: '分割窗口',
  markdown_page: 'Markdown編輯器',
  editor_page: '富文本編輯器',
  icons_page: '自定義圖標',
  img_cropper_page: '圖片編輯器',
  join_page: 'QQ群',
  doc: '文檔',
  update_table_page: '上傳CSV文件',
  update_paste_page: '粘貼表格數據',
  multilevel: '多級菜單',
  directive_page: '指令',
  excel: 'Excel',
  'upload-excel': '上傳excel',
  'export-excel': '導出excel',
  tools_methods_page: '工具函數',
  drag_list_page: '拖拽列表',
  i18n_page: '多語言',
  modalTitle: '模態框題目',
  content: '這是模態框內容',
  buttonText: '顯示模態框',
  'i18n-tip': '註：僅此頁做了多語言，其他頁面沒有在多語言包中添加語言內容',
  error_store_page: '錯誤收集',
  error_logger_page: '錯誤日誌',
  error: '錯誤',
  query: '帶參路由',
  params: '動態路由',
  cropper_page: '圖片裁剪',
  message_page: '消息中心',
  tree_table_page: '樹狀表格',
  org_tree_page: '組織結構樹',
  drag_drawer_page: '可拖動抽屜',
  tree_select_page: '樹狀下拉選擇器',
  welcome: '歡迎登錄',
  out_full_screen: '退出全屏',
  in_full_screen: '全屏',
  fixConfGroup: '固定會議',
  temConfGroup: '臨時會議',
  invite: '邀請',
  kick: '移出',
  mute: '靜音',
  cmute: '取消靜音',
  allmute: '全靜音',
  allcmute: '取消全靜音',
  cfstart: '開始會議',
  cfclose: '關閉會議',
  current_conferece: '當前會議',
  confNotOpen: '當前會議未開始',
  confIsOpen: '當前會議已開始',
  callConfList: '會議信息',
  confMember: '會議成員',
  EnterConference: '進入',
  LeaveConferce: '離開',
  MuteConference: '靜音',
  CancelMuteConference: '解靜',
  inconf: '在',
  Input_placeholder: '請輸入',
  highInfo: '高級設置',
  baseInfo: '基本設置',
  KeyCollection: '采集按鍵',
  key_number: '按鍵數',
  not_enter_number: '未按鍵通知次數',
  call_lasting_time: '通話時長',
  start_tip: '啟用提示',
  notice_not_start_tip: '通知未啟用，是否現在啟用並播放',
  broad_not_start_tip: '廣播未啟用，是否現在啟用並播放',
  /**************上報信息 **************/
  reporting_information_is_read: '是否已讀',
  reporting_information_upload_info: '上報信息',
  reporting_information_all_info: '全部信息',
  reporting_information_has_read: '已讀狀態',
  reporting_information_not_read: '未讀狀態',

  upInfo_col_index: '序號',
  upInfo_col_id: '信息ID',
  upInfo_col_title: '上報標題',
  upInfo_col_content: '上報內容',
  upInfo_col_isRead: '是否已讀',
  upInfo_col_upUserName: '上報人員',
  upInfo_col_address: '上報地址',
  upInfo_col_file_path: '附件',
  upInfo_col_upTime: '上報時間',
  upInfo_col_file_comments: '評論',
  upInfo_col_baseInfo: '基本信息',
  upInfo_col_open_comments: '展開評論',
  upInfo_col_close_comments: '收起評論',
  upInfo_col_click_me: '點我跳轉',
  upInfo_col_no_attach: '暫無附件',
  upInfo_col_view_detail: '詳情',
  upInfo_col_has_read: '已讀',
  upInfo_col_not_read: '未讀',
  upInfo_col_not_support_preview: '不支持預覽',
  upInfo_col_modal_not_support_preview: '暫不支持預覽該文件',

  upInfo_tip_add_success: '添加成功',
  upInfo_tip_add_fail: '添加失敗',
  upInfo_tip_update_success: '更新成功',
  upInfo_tip_update_fail: '更新失敗',
  upInfo_tip_select_one: '請先選中一行信息',
  upInfo_tip_enter_comment: '請輸入評論',
  upInfo_tip_comment_not_blank: '評論不能為空',
  upInfo_tip_comment_last_editing: '請先編輯完上一條評論',

  upInfo_action_push: '發布',
  upInfo_action_reset: '重置',
  upInfo_action_edit: '編輯',

  display_more: '更多',
  /**顯示更多下的菜單名指定(采用單個英文)**/
  more_menu_control: '控製臺',
  more_menu_conference: '會議室',
  more_menu_video_conference: '視頻會議',
  more_menu_broadcast: '廣播任務',
  more_menu_standGuard: '無人看守',
  more_menu_warning: '警報預案',
  more_menu_video: '視像監控',
  more_menu_map: '電子地圖',
  more_menu_gis_map: 'GIS調度',
  more_menu_dispatch: '通訊調度',
  more_menu_channel: '頻道會話',
  more_menu_reserve_plan: '預案',
  more_menu_queuing_notice: '排程通知',
  more_menu_contacts: '聯絡人',
  more_menu_reporting_information: '上報信息',
  more_menu_system: '系統管理',

  // 菜单右击
  add_to_more: '添加到更多',
  move_forward: '前移',
  move_back: '後移',
  remove_more: '移出更多',
  remove_fail: '空間不足，移出失敗',

  display_control: '顯示終端',
  system_theme: '系統主題',
  outCallAutoAnswer:'外置呼出自動接聽',

  theme_black: '黑色',
  theme_white: '白色',
  theme_blue: '藍色',

  language: '系統語言',
  system_version: '系統版本',

  state_search: '狀態篩選',
  type_search: '類型篩選',

  /*類型篩選*/
  mode_phone: '話機',
  mode_speak: '對講',
  mode_broad: '廣播',
  mode_door: '門禁',
  mode_pc: '話務臺',
  mode_car: '車載臺',
  mode_voice: '調音臺',
  mode_view: '視像終端',
  mode_other: '其他',
  camera_type: '攝像頭',
  type_label: '類型',
  sure_logout: '確認退出?',
  expire: '無效許可證，請聯系管理員或登錄系統管理頁面更換許可',
  noLicense: '無許可證，請聯系管理員或登錄系統管理頁面更換許可',
  license_warn:'許可證有效期剩余{day}天，請及時更新！',
  tamper_alarm: '防拆警報',
  one_alarm: '一鍵警報',
  gateway_alarm: '網關警報',
  motion_alarm: '移動偵測',
  helmet_alarm: '安全帽報警',

  please_select_device_dept: '請選擇所屬分區',

  self_check: '自檢任務',
  nowSelfCheck: '即時自檢',
  timerSelfCheck: '定時自檢',
  selfCheck_name: '名稱',
  selfCheck_status: '狀態',
  selfCheck_mode: '模式',
  selfCheck_cycle: '執行周期',
  selfCheck_playTime: '執行時間',
  selfCheck_all: '檢測總數',
  selfCheck_normals: '正常數',
  selfCheck_abnormals: '不正常數',
  selfCheck_enable: '啟用',
  self_check_excute: '執行',
  self_check_result: '自檢結果',
  self_check_time: '自檢時間',
  self_check_current_result: '最新結果',
  self_check_history_result: '歷史結果',
  no_select_self_check: '請選擇自檢任務',
  self_check_update_title: '編輯自檢任務',
  self_check_add_title: '添加自檢任務',
  self_fixed_time: '固定',
  self_cycle_time: '循環',
  self_result_nostart: '未開始',
  self_result_checking: '自檢中',
  self_result_normal: '正常',
  self_result_abnormal: '異常',
  self_fail_tip: '說明',
  self_result_uptime: '結束時間',
  self_result: '自檢結果',
  self_name: '設備名',
  self_fail_device: '設備異常',
  self_fail_offline: '設備離線',
  self_fail_overtime: '設備超時',
  self_fail_busy: '設備忙碌',
  self_check_exist: '自檢任務已存在',
  self_check_name: '自檢名稱不能為空',
  self_check_extens: '自檢終端不能為空',
  self_check_deptId: '分區不能為空',
  video_conference_no_limit: '視頻會議方數已達上限',

  //通知
  system_notice: {
    title: {
      warn: '數據預警通知',
      delete: '數據刪除通知',
      selfCheck: '自檢異常',
      change: 'HA通知',
      alarm: '報警預案通知'
    },
    turnToClean: '點擊跳轉清理',
    turnToDetail: '點擊查看詳情',
    turnToHA: '點擊查看HA狀態',
    self: {
      device: '終端',
      abnormal: '異常'
    },
    operator: {
      backing: '系統正在備份中，請勿操作',
      reset: '系統正在還原中，請勿操作',
      reboot: '系統正在初始化中，請勿操作',
      upgrade: '系統正在升級中，請勿操作',
    }
  },
  public: '公有',
  self: '私有',
  all_group: '全部分組',

  device_offline: '終端不在線',
  no_broad_menu: '無調度權限',
  dept: '分區',
  conf: '會議',
  conf_link: '會議聯動',
  voice_conf_link: '語音會議聯動',
  notice_link: '通知聯動',
  conf_name: '會議名稱',
  hourly_chime: '整點報時',
  hourly_chime_exits: '報時任務已存在',
  cascade_manager: '級聯管理',
  chime_play_time: '執行時間',
  chime_time_line: '播報時間段',
  placeholderTimeLine: '請選擇播報時間段',
  chime_time_name: '報時任務名稱不能為空',
  chime_time_terminal: '報時終端不能為空',
  timeLineEmpty: '播報時間段不能為空',
  no_select_chime_task: '請選擇報時任務',
  chime_task: '報時任務',
  add_chime_task: '添加整點報時任務',
  update_chime_task: '編輯整點報時任務',
  tips: '提示',
  only_number: '只能輸入數字',
  page_count_overflow: '不能超過當前最大頁面,已自動查詢最後一頁',
  greater_than: '大於',
  less_than: '小於',
  greater_than_or_equal: '大於等於',
  less_than_or_equal: '小於等於',
  equal: '等於',

  link_phone_tips: '連絡人號碼需7位以上才可在固定會議室被邀請',
  plan_has_no_link: '預案未添加聯動,請先添加聯動',
  plan_has_link: '預案聯動已存在',
  jump_to: '跳至',
  page: '頁',
  app_login: '抱歉，您非本系統用戶！',
  broadTimeAndCom: '播放時長(分)',
  no_system_menu: '無系統管理權限',
  is_open: '已啟用',
  is_closed: '未啟用',
  start_plan: '觸發預案',
  stop_plan: '停止預案',
  dept_alarm: '啟動報警',
  dept_clear: '關閉報警',
  output_port: '輸出口',
  enter_manager: '進入管理',
  show_all_child: '顯示所有下級數據',
  broad_overview: '廣播概覽',
  cascade_all: '全部廣播',
  cascade_running: '進行中廣播',
  cascade_offline: '離線廣播',
  cascade_text: '文字廣播',
  cascade_shout: '喊話廣播',
  cascade_music: '音樂廣播',
  cascade_timing: '定時廣播',
  default_time: '默認時間',
  no_default_time:'請選擇默認時間',
  employee_state: '終端狀態',
  system_area: '系統區域',
  change_fresh_time: '數據刷新',
  fresh_success: '刷新成功',
  fresh_fail: '刷新失敗',
  every_part: '每隔',
  second_refresh: '秒刷新',
  seconds: '秒',
  cascade_tip_one: '級聯管理中的概況數據刷新時間間隔，默認5秒',
  cascade_tip_two: '勾選後顯示選中的及其所有下級系統的數據',
  un_register: '未註冊',
  add_broad: '新建廣播',
  select_bro: '選擇廣播',
  to_be_select_broad: '待選廣播',
  selected_broad: '已選廣播',
  delete_broad_plan: '删除方案?',
  enable_plan_tips: '系統中僅可啟用一條方案,是否覆蓋目前已啟用方案?',
  plan_name_not_empty: '名稱不能為空',
  select_holiday_time:'請選擇節假日起始日期',
  select_start_time: '請選擇開始時間',
  select_end_time: '請選擇結束時間',
  broad_day: '按天循環',
  every_day: '每天',
  broad_not_enable: '當前廣播已被以下方案使用，請移出後再次啟用',
  broad_plan_not_delete: '當前方案已被方案切換使用，無法刪除',
  broad_plan_not_enable: '當前方案已被方案切換使用，無法啟用',
  time_have_same: '當前時間和其餘數據存在交集，請更改時間',
  edit_not_enable: '當前廣播已被以下方案使用，默認未啟用',
  not_null: '不能為空',
  start_big_end: '結束時間不能小於開始時間',

  grade_register: '系統已註冊',
  grade_online: '系統在線未註冊',
  grade_offline: '系統離線',
  grade_main_system: '主系統',
  video_surveillance: '監視',
  plan_exist: '廣播方案已存在',
  broad_not_delete: '當前廣播已被以下方案使用，無法刪除',
  current_video_call: '當前視頻通話',
  surveillance_video: '監視視頻',
  caller: '主叫號',
  callee: '被叫號',
  systemForCascade: '系統',

  already_exists: '已存在',
  sys_offline: '系統不線上未獲取到數據',
  broad_cascade: '級聯廣播',
  delete_cascade: '級聯廣播會將子系統廣播删除，是否繼續？',
  outside_system: '外部系統',
  add_cascade: '已選分機樹中存在不線上的系統未獲取到分機數據，是否繼續保存！',
  system_role: '未擁有系統管理許可權，請聯系管理員設定角色許可權',
  same_name_notice: '通知名稱已存在',
  content_too_long: '文字內容超長',
  audio_not_support: '文件不支持MP3高音質，請重新上傳',
  terminal_not_allowed: '采播終端不允許在喊話列表中',
  textType: '文字消息通知',
  out_of_authority: '許可權外',
  start: '啟動',
  send_status: '發送狀態',
  text_is_too_long: '文字內容不能超過500字節',
  text_is_send: '已發送的文字通知不允許編輯',
  text_have_character: '文字內容不允許包含 “|”',
  text_have_content: '文字內容不允許包含xml格式的 “content”',
  camera_foreach: '輪巡攝像頭',
  please_setting_camera: '請配置輪巡攝像頭',
  enable_camera: '啟用輪巡',
  camera_time_interval: '輪巡間隔(秒)',
  not_select_camera: '待選攝像頭',
  selected_camera: '已選攝像頭',
  time_no_lg: '間隔時間不能小於5秒',
  is_opening: '當前正在輪巡中',
  is_not_two_page: '攝像頭不足兩組,輪巡自動關閉',
  is_loading_data: '數據加載中，請稍後',
  pause_robin: '暫停輪巡',
  resume_robin: '恢復輪巡',
  gateway_output: '網關輸出口',
  port_name: '端口名稱',
  un_select_port: '請選擇端口',
  broad_mpa: '1.廣播源文件高於320kbps采樣率時，該廣播語音文件以320kbps采樣率播放，當源文件低於320kbps采樣率時，該廣播語音文件按實際采樣率播放。\n' +
    '2.已選終端不支持MPA編碼無法接通MP3高音質廣播。\n' +
    '3.MP3高音質廣播不支持廣播下級級聯終端。\n' +
    '4.MP3高音質廣播不支持調節音量。\n' +
    '5.于2.2.7版本之前上傳的音樂文件，不支持MP3高音質，開啟後會出現無聲現象。',
  video_isRecording: '該視頻正在錄屏中，是否停止錄屏並關閉？',
  camera_recording: '該攝像頭正在錄屏中',
  broad_start_file: ' 廣播開始提示音',
  no_quick_operate: '請勿頻繁操作',
  epx_name: 'EPX配置管理系統',
  password_old_tip: '為了系統安全，請修改系統初始密碼，是否立即修改？',
  system_tip: '系統提示',
  modify_now: '立即修改',
  next_modification: '下次修改',
  broad_user: '調度員',
  voice_meeting: '語音會議',
  video_meeting: '視頻會議',
  video_out_license: '視頻會議超出成員上限',
  upload_music_file: '上傳語音文件',
  meeting: {
    record: {
      pre: '會議室：',
      stop: '停止錄像',
      start: '開始錄像',
      not_stop: '錄像不能關閉',
    },
    content: {
      record: '錄像',
      nick: '昵稱',
      ip: 'IP'
    },
    warning: {
      in_room: '您已在會議室：${roomName}！'
    },
    btn: {
      no_select: '未選中會議室',
      setting: '設置',
      full: '全屏',
      join: '加入',
      leave: '退出',
      disableCamera: '禁用攝像頭',
      enableCamera: '啟用攝像頭',
    },
    setting: {
      camera: '攝像頭',
      mic: '麥克風',
      speak: '揚聲器',
      check:'請檢查',
      permission:'權限'
    },
    right: {
      meeting: '開會中',
      unMeeting: '未加入'
    },
    invite: {
      title: '視頻會議邀請',
      content_pre: '調度員：',
      content_suf: '，邀請您加入視頻會議：',
      join: '加入',
      reject: '拒絕'
    },
    share:{
      info:'共享屏幕',
      start:'開始共享屏幕',
      end:'結束共享屏幕',
      no_access:'您無權結束共享',
      sharing:'正在共享屏幕',
    }
  },
  gis_map: {
    map: {
      name:'地圖名稱',
      order:'地圖排序',
      img:'地圖',
      manager: '底圖管理',
      max_zoom: '地圖已放大到最大',
      min_zoom: '地圖已縮小到最小',
      start_distance: '點擊地圖開始測距',
      continue_distance: '單擊地圖繼續測距或雙擊結束測距',
      continue_fence: '單擊地圖繼續繪製或雙擊結束繪製',
      modify: '拖動修改測距',
      update_success: '更新終端位置成功',
      update_fail: '更新終端位置失敗，請稍後重試！',
      add_success: '添加終端成功',
      add_exits: '添加終端失敗，終端已存在！',
      add_fail: '添加終端失敗，請稍後重試！',
      delete_success: '刪除終端成功',
      delete_fail: '刪除終端失敗，請稍後重試！',
      load_fail: '加載終端數據失敗，請稍後重試！',
      change_map: '請切換到對應的場景圖下！',
      upload_success: '上傳場景圖成功',
      upload_fail: '上傳場景圖失敗，請稍後重試！',
      transfer_fail: '場景圖轉換失敗，請稍後重試！',
      uploading: '場景圖上傳中',
      lng: '經度',
      lat: '維度',
      out_map: '請添加在場景圖範圍內！',
      review: '重置',
      zoom_in: '縮小',
      zoom_out: '放大',
      distance: '測距',
      box_select: '框選',
      circle_select: '圈選',
      browse_current: '瀏覽',
      browse_exit: '退出瀏覽',
      box_select_disabled: '框選（請先退出瀏覽模式）',
      circle_select_disabled: '圈選（請先退出瀏覽模式）',
      fence: '圍欄',
      upload: '上傳',
      scene_manager:'底圖管理',
      gltf_tip: '三維地圖模型標準，存 3D 模型',
      geojson_tip: '二維地圖矢量數據標準，存座標和地理屬性',
      name_required: '請填寫地圖名稱',
      img_required: '請上傳圖片文件',
      gltf_required: '請上傳3D模型文件或矢量數據',
      sort_required: '請填寫地圖排序',
      sort_must_number: '地圖排序必須是數字',
      sort_more_than_zero: '地圖排序必須大於0',
      all_mode_edit_forbidden: '全部模式下無法編輯數據，請點擊指定樓層後再操作',
      scene_not_configured: '請先在底圖管理中配置場景圖，再部署終端',
      webgl_unavailable: '3D地圖無法載入，瀏覽器未開啟硬體加速',
      edit_single_only: '編輯時只能選擇一條數據',
      type:'底圖類型',
      select_data_required: '請選擇數據',
      delete_success_msg: '刪除成功',
      save_success_msg: '保存成功',
      gltf_file_format_error: '請選擇 .glb 或 .gltf 文件',
      add_map_title: '添加底圖',
      edit_map_title: '編輯底圖',
      col_name: '名稱',
      col_type: '類型',
      col_username: '上傳用戶',
      col_sort: '排序',
      not_own_partition_map: '只能編輯或刪除同一分區用戶上傳的底圖',
      confirm_delete_maps: '確認刪除已選中的 {count} 張底圖：{names}？'
    },
    app_select: {
      title: 'APP用戶',
      from_title: '待選用戶',
      to_title: '已選用戶',
      search: '請輸入關鍵字',
    },
    select: {
      title: '選擇終端',
      current_pre: '當前選擇：',
      current_suf: '個終端',
      voice_conf: '語音會議',
      video_conf: '視頻會議',
      multi_pro: '多方喊話',
      multi_bro: '多方廣播',
      batch_delete: '批量刪除',
      no_selected: '未選中終端',
      operation_selected: '請選擇需要操作的終端！',
      not_support_delete: 'App終端不支持刪除'
    },
    fence: {
      setting: {
        title: '圍欄設置',
        name: '名稱',
        name_placeholder: '請輸入圍欄名稱',
        time: '時間',
        time_placeholder: '請選擇圍欄時間範圍',
        remark: '備註',
        remark_placeholder: '請輸入圍欄備註',
        type: {
          no_enter: '禁入',
          no_leave: '禁出'
        },
        btn: {
          add: '添加用戶',
          delete: '刪除用戶',
          save: '保存',
          cancel: '取消'
        },
        columns: {
          name: '名稱',
          number: '號碼'
        },
        warn: {
          name: '圍欄名稱不能為空',
          start_time: '圍欄開始時間不能為空',
          end_time: '圍欄結束時間不能為空',
          edit: {
            success: '圍欄更新成功！',
            fail: '圍欄更新失敗，請稍後重試！',
            exits: '圍欄更新失敗，圍欄名稱已存在！'
          },
          point: '圍欄數據不能為空',
          add: {
            success: '圍欄添加成功！',
            fail: '圍欄添加失敗，請稍後重試！',
            exits: '圍欄添加失敗，圍欄名稱已存在！'
          }
        }

      }
    },
    track: {
      play_title: '軌跡回放',
      time: '時間選擇',
      speed: '移動速度',
      time_placeholder: '請選擇時間範圍',
      btn: {
        play: '播放',
        pause: '暫停',
        clear: '清空',
        query: '獲取軌跡'
      },
      detail_title: '軌跡詳情',
      lat: '維度',
      lng: '經度',
      warn: '加載軌跡出錯，請稍後重試！'
    },
    position: {
      title: '當前位置',
      lng: '經度：',
      lat: '緯度：',
      time: '時間：'
    },
    overlay: {
      track: '軌跡',
      delete: '刪除'
    },
    search: {
      select: '請輸入終端名稱或分機號',
      fence: {
        title: '電子圍欄',
        name: '名稱',
        time: '時間',
        number: '人數',
        type: '類型',
        no_enter: '禁入',
        no_leave: '禁出',
        delete: {
          title: '刪除圍欄',
          content: '確認刪除圍欄：',
          ok: '確認',
          cancel: '取消',
          success: '圍欄刪除成功！',
          fail: '圍欄刪除失敗，請稍後重試！'
        }
      },
      warn_content: '告警記錄',
    },
    warn: {
      title: '告警記錄',
      columns: {
        name: '圍欄名稱',
        type: '圍欄類型',
        member: '成員名稱',
        time: '告警時間'
      },
      enter: '進入',
      leave: '離開',
      tip_title: '圍欄告警',
      warn_prefix: '終端：',
      warn_s: '在',
    }
  },
  deleteBroadFail: '廣播已被聯動任務使用，刪除失敗',
  member_info: '成員信息',
  longitude: '經度',
  latitude: '緯度',
  monitorOnly: '監控',
  appUser: 'APP',
  status: '狀態通知',
  status_tip: {
    status: '狀態',
    device: '設備',
    time: '時間',
    content: '內容'
  },
  ext: '分機',
  online: '上線',
  extOffline: '下線',
  meetingConf: '會議',
  isLoading: '正在加載中',
  control_search: '請輸入號碼或名稱',
  last_play_time: '最近播放時間',
  broad_log_columns: {
    name: '廣播名稱',
    play_time: '播放時間',
    all_number: '終端數量',
    answer_number: '接聽數量',
    callee_number: '號碼',
    callee_name: '名稱',
    answer_time: '開始時間',
    is_answer: '通話狀態',
    duration_time: '通話時長',
    hangup_reason: '掛斷原因',
    answer_state: '已接通',
    no_answer_state: '未接通',
    detail: '廣播記錄詳情'
  },
  hangup_reason: {
    user_busy: '座席忙時外呼',
    523: '黑名單',
    524: '網關離線或路由錯誤',
    no_answer: '客戶未接通',
    normal_clearing: '正常掛斷',
    no_user_response: '用戶無響應',
    originator_cancel: '發起方取消',
    db_error: '數據異常',
    no_route_destination: '無路由',
    normal_unspecified: '未知異常',
    call_rejected: '被叫拒接',
    normal_temporary_failure: '盲轉外線，路由錯誤',
    200: '正常掛機',
    fake_event: '座席掉線',
    fake_event_reload: '分機掉線',
    unknown: '未知',
    offline: '分機離線',
    manager_request: '達到限呼時長',
    outgoing_call_barred:'達到限呼時長',
    other_answer:'被代接',
  },
  input_number: '輸入號碼',
  call_record: '最近音視頻記錄',
  communication_dispatch: {
    link: '通訊錄',
    dispatch: '調度組',
    conf: '分組會議',
    group: '分組'
  },
  report: {
    menu: '報表管理',
    left: {
      call_record: '通話記錄',
      audio_record: '錄音報表',
      shout_image: '抓圖記錄',
      alarm_record: '告警記錄',
      status_record: '狀態記錄'
    },
    column: {
      call: {
        call_status: '呼叫狀態',
        caller_number: '主叫號',
        caller_name: '主叫名稱',
        called_number: '被叫號',
        called_name: '被叫名稱',
        start_time: '開始時間',
        talk_status: '通話狀態',
        duration_time: '通話時長',
        rate: '費率類型',
        money: '金額',
        hangup_reason: '掛斷原因'
      },
      audio: {
        account_name: '錄製賬戶名',
        start_time: '錄製開始時間',
        caller_number: '主叫號',
        caller_name: '主叫名稱',
        called_number: '被叫號',
        called_name: '被叫名稱'
      },
      shout: {
        name: '圖像名稱',
        time: '抓圖時間',
        camera_name: '攝像頭標識名',
        device_name: '抓圖終端'
      },
      status:{
        device_name:'終端名稱',
        exten:'分機號',
        device_type: '終端類型',
        status:'類型',
        create_time:'發生時間',
        register_ip:'註冊IP',
        register_port:'端口'
      },
      search: {
        call: {
          coming: '呼入',
          outing: '呼出',
          inside: '內線',
          answer: '已接通',
          no_answer: '未接通'
        }
      }
    },
    btn: {
      export: '導出',
      batch_download: '批量下載',
      batch_delete: '批量刪除',
      download_audio: '下載錄音',
      play_audio: '播放錄音',
      download_video: '下載錄像',
      play_video: '播放錄像',
      delete: '刪除',
      download_image: '下載截圖',
      view_image: '查看截圖'
    },
    filter: {
      label: '條件篩選',
      value1: '按選擇結果',
      value2: '按搜索結果'
    },
    model: {
      title1: '導出記錄',
      title2: '批量下載',
      title3: '批量刪除',
      title4: '刪除錄音',
      title5: '查看',
      content1: '確認刪除此錄音？',
      title6: '刪除告警記錄',
      content2: '確認删除？',
    },
    tip: {
      no_select: '請選擇數據',
      no_data: '無錄音或錄像',
    },
    name: {
      broadcast: '廣播',
      announce: '多方喊話',
      pagegroup: '組播模式廣播',
      conference: '會議'
    }
  },
  alarm_device: '報警終端',
  plea: '報警終端',
  yesterday: '昨天',
  channel: '頻道',
  session: '會話',
  please_input_name: '請輸入頻道或會話名稱',
  name_too_long: '名稱過長，需要在20個字符以內',
  name_exits: '名稱已存在',
  chat_input_tip: 'Enter發送，Shift+Enter換行',
  please_input_info: '請輸入發送內容',
  emoji: '表情',
  img: '圖片',
  position: '定位',
  select_member: '選擇成員',
  current_member: '個成員',
  please_select_mem: '請選擇成員',
  position_messages: '定位消息',
  session_detail: '會話詳情',
  session_name: '會話名稱',
  delete_session: '解散會話',
  exit_session: '退出會話',
  delete_member: '移出成員',
  delete_member_tip: "是否確認移出？",
  exit_session_tip: '是否確認退出會話？',
  delete_session_tip: '解散會話會將所有記錄清除，是否確認？',
  upload_fail: '上傳失敗',
  img_upload_fail_tip: '文件格式錯誤，請上傳JPEG/PNG/JPG/GIF格式圖片。',
  img_max_tip: '超出圖片大小限製，上傳文件不能超過',
  audio_max_tip: '超出語音大小限製，上傳文件不能超過',
  video_max_tip: '超出視頻大小限製，上傳文件不能超過',
  file_max_tip: '超出文件大小限製，上傳文件不能超過',
  audio_type_error: '文件格式錯誤，請上傳mp3/amr/mp4/格式文件。',
  add_member: '添加成員',
  invite_members: '邀請成員',
  to_select_mem: "待選成員",
  selected_mem: "已選成員",
  kick_member: "移出了",
  member_leave: "退出了會話",
  invite_member: "邀請了",
  change_name: '修改會話名為',
  change_channel_name: '修改頻道名為',
  create_session: '創建會話',
  member_no_operate: '成員未做操作',
  member_over: '成員超出200上限',
  channel_no_access: '無會話修改權限',
  no_member: '請選擇成員',
  system_user: '系統用戶',
  session_name_empty: '會話名稱不能為空',
  member_search_tip: '請輸入成員名稱或分機號',
  el: {
    transfer: {
      noMatch: '無匹配數據',
      noData: '無數據',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '請輸入搜索內容',
      noCheckedFormat: '共 {total} 項',
      hasCheckedFormat: '已選 {checked}/{total} 項'
    },
  },
  quickButton: '快捷按鍵',
  quickBtn: '快捷键',
  quickButtonSetting: '快捷按键配置',
  value: '值',
  moveUp: '上移',
  moveDown: '下移',
  sureCall: '是否確認呼叫',
  sureClick: '是否確認觸發',
  nullForQuickBtn: '快捷按键值爲空',
  defaultOpen: '默認展開',
  access_pwd_be_number: '接入號密碼必須是數字',
  quick_btn_exits: '快捷鍵名稱已存在',
  first_one: '已移到最前一個',
  last_one: '已移到最後一個',
  alarmTime:'告警時間',
  queue_answer_error:'當前通話無需搶接，請直接接聽',
  queue_answer_left: '請在話機上接聽',
  e_broad:{
    set_emergency: '配置緊急廣播',
    config:'配置',
    no_emergency:'暫無緊急廣播',
    disabled: '未啟用',
    enable:'啟用',
    stop:'停用',
    access_pwd:'密碼',
    selectOrInput:'請輸入或選擇'
  },
  surveillance:{
    srsTip: '請先於基本配置中完成媒體服務器地址配置'
  },
  noticeDetails:'通知記錄',
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-TW.js